import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsbancariosCompletadosLayout', {
    template: template,
    controller: NominaDocumentosLayoutsbancariosCompletadosLayoutComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      idLayout: '<',
      idBanco: '<',
      idCuenta: '<',
      fechaPago: '<',
      interbancario: '<',
      banco: '<',
      numeroCuenta: '<',
      moneda: '<',
      creadoFecha: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsbancariosCompletadosLayoutComponent(NominaDocumentosLayoutsbancariosLayout) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.cerrar = cerrar
  $ctrl.descargando = false
  $ctrl.eliminar = eliminar
  $ctrl.error = null
  $ctrl.seleccionar = seleccionar
  $ctrl.total = undefined

  function $onInit() {
    $ctrl.promise = NominaDocumentosLayoutsbancariosLayout.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.idLayout)
      .then(function (response) {
        $ctrl.data = response.data
      })
  }

  function cerrar() {
    $ctrl.onClose()
  }

  function eliminar(seleccionados) {
    seleccionados.forEach(function (item) {
      item.status = false
    })

    $ctrl.data = [].concat($ctrl.data)

    let data = {
      colaboradores: $ctrl.data.reduce(function (total, next) {
        return total + (next.status ? 1 : 0)
      }, 0),
      total: $ctrl.data.reduce(function (total, next) {
        return total + (next.status ? next.importe : 0)
      }, 0),
    }

    $ctrl.onChange({$event: {data: data}})
  }

  function seleccionar(seleccionados) {
    $ctrl.seleccionados = seleccionados

    $ctrl.total = $ctrl.seleccionados.reduce(function (total, item) {
      return total + item.importe
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsbancarios/completados/layout/component.js